let code = 'cemgestao';
let codeAPI = 'cem';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};